
import React from 'react'
import axios from 'axios'
import { Container, Subscribe, Provider } from 'unstated'

class IPContainer extends Container {
  constructor() {
    super()

    this.state = {}

    if (typeof window !== 'undefined') {
      axios.get('https://api.ipstack.com/check?access_key=e69cd65fae4eaaf1aee0733bac46a5c6')
        .then(res => {
          try {
            const { data } = res
            const { region_code } = data
            this.state.region = region_code
          } catch(err) {
            console.log(err)
          }
        })
    }
  }

}

export const ipContainer = new IPContainer()
export const IPSubscriber = ({ children }) => (
  <Provider>
    <Subscribe to={[ipContainer]}>
      { children }
    </Subscribe>
  </Provider>
)